import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;

  background-color: ${(props) => props.theme.colors.whiteSmoke};
`;

export const BlackBar = styled.div`
  width: 100%;
  height: 24px;
  background-color: ${(props) => props.theme.colors.black};
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 74px;
  margin-top: 78px;
`;

export const SubtitleText = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-style: italic;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: ${(props) => props.theme.colors.black};
  margin: 0;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 clamp(24px, 8.6vw, 124px);
`;

export const HeadingText = styled.h1`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 48px;
  line-height: 130%;
  color: ${(props) => props.theme.colors.black};
  margin: 0;

  @media ${(props) => props.theme.device.laptop} {
    font-size: 64px;
  }

  @media ${(props) => props.theme.device.laptopL} {
    font-size: 72px;
  }
`;

export const VideoSection = styled.div`
  width: 100%;
  margin-top: 72px;
  padding: 0 24px 80px;
  display: flex;
  justify-content: center;

  @media ${(props) => props.theme.device.tablet} {
    margin-top: 124px;
    padding: 0 24px;
  }
`;

export const MarqueeSection = styled.div`
  position: relative;
  width: 100%;

  border-top: 1px solid ${(props) => props.theme.colors.gray12};
  border-bottom: 1px solid ${(props) => props.theme.colors.gray12};

  margin-top: 72px;

  @media ${(props) => props.theme.device.tablet} {
    margin-top: 124px;
  }
`;

export const MarqueeText = styled.div`
  span {
    font-family: ${(props) => props.theme.fontFamilies.sfPro};
    font-size: 28px;
    line-height: 150%;

    &:last-child {
      font-family: ${(props) => props.theme.fontFamilies.vollkorn};
      font-style: italic;
    }
  }
`;

export const GallerySection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 0 auto;
  max-width: 1440px;
  padding: 80px 24px 60px;

  @media ${(props) => props.theme.screen.sm} {
    padding: 100px 72px 80px;
  }

  @media ${(props) => props.theme.screen.md} {
    padding: 100px 120px 80px;
  }

  @media ${(props) => props.theme.screen.xl} {
    padding: 130px 200px 84px;
  }
`;

export const GalleryHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`;

export const GalleryHeadingText = styled.h3`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 64px;
  line-height: 130%;
  margin: 0;
`;

export const GalleryHeadingSubtitle = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: 400;
  font-style: italic;
  font-size: 32px;
  line-height: 140%;
  letter-spacing: 2%;
  margin: 0;
  align-self: center;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

export const FeaturedCardWrapper = styled.div`
  width: 100%;
`;

export const OrganizationCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media ${(props) => props.theme.screen.sm} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${(props) => props.theme.device.laptop} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${(props) => props.theme.device.laptopL} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const LastUpdatedText = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;

  margin-top: 56px;

  * {
    font-family: ${(props) => props.theme.fontFamilies.vollkorn};
    font-size: 16px;
    text-align: center;

    &:first-child {
      line-height: 180%;
      text-decoration: underline;
      text-underline-offset: 8px;

      transition: text-decoration 0.3s ease;

      &:hover {
        cursor: pointer;
        text-decoration: none;
      }
    }
  }

  @media ${(props) => props.theme.screen.md} {
    font-size: 20px;
  }

  @media ${(props) => props.theme.screen.md} {
    margin-top: 112px;
  }
`;

export const StorySectionMarqueeDivider = styled.div`
  margin-top: 46px;
  margin-bottom: 130px;

  border-top: 1px solid ${(props) => props.theme.colors.gray12};
  border-bottom: 1px solid ${(props) => props.theme.colors.gray12};
`;

export const StorySectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StorySectionHeading = styled.h1`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 56px;
  line-height: 130%;
  letter-spacing: -2%;
  margin: 0;

  padding-left: 48px;
  padding-bottom: 64px;
  align-self: flex-start;

  @media ${(props) => props.theme.device.tablet} {
    font-size: 72px;
  }

  @media ${(props) => props.theme.screen.xxl} {
    padding-left: 12.5%;
  }

  @media ${(props) => props.theme.device.desktop} {
    padding-left: 25%;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
